<template>
  <div>
    <div class="vx-row" id="formulation_qa_table">
      <div class="vx-col w-full">
        <vx-card no-shadow>
          <template slot="actions">
            <vs-button v-if="$canAny(formulationDgnPermissions)" @click="onClickSave()" class="mr-0" color="primary" size="small"
                       type="filled">Save Changes
            </vs-button>
          </template>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="is_dgn_required" name="is_dgn_required" rules="" v-slot="{ errors }">
                <small class="label">DGN Required?</small>
                <vs-switch v-model="is_dgn_required" icon-pack="feather" vs-icon-on="icon-check-circle"
                           :disabled="!$canAny(formulationDgnPermissions)"
                           vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="is_dgn_required">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="un_number" name="un_number" rules="" v-slot="{ errors }">
                <small class="label">UN Number</small>
                <vs-input v-model="form.un_number" name="un_number" class="w-full" label="" :danger="!!errors[0]"
                          :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                          :disabled="!$canAny(formulationDgnPermissions)"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="hazard_class_number" name="hazard_class_number" rules="" v-slot="{ errors }">
                <small class="label">Transport Hazard Class</small>
                <vs-input v-model="form.hazard_class_number" name="hazard_class_number" class="w-full" label=""
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather"
                          :disabled="!$canAny(formulationDgnPermissions)"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="is_dgn_required">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="flash_point" name="flash_point" rules="" v-slot="{ errors }">
                <small class="label">Flash Point</small>
                <vs-input v-model="form.flash_point" name="flash_point" class="w-full" label="" :danger="!!errors[0]"
                          :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                          :disabled="!$canAny(formulationDgnPermissions)"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="is_dgn_required">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Proper Shipping name</small>
                <vs-textarea class="mb-0" v-model="form.description" height="100px"
                             :disabled="!$canAny(formulationDgnPermissions)"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

const FormulationsRepository = RepositoryFactory.get('formulations')

export default {
  name: "FormulationDangerousGoodNoteTab",
  data() {
    return {
      formulationId: '',
      form: {},
      is_dgn_required: false
    }
  },
  props: {
    formulation_data: {
      type: Object,
      default: {},
    },
    formulationPermissions: {
      type: Array,
      default: [],
    }
  },
  methods: {
    async onClickSave() {
      try {
        const payload = {}
        Object.assign(payload, this.form)
        payload.is_dgn_required = this.is_dgn_required
        await FormulationsRepository.updateDangerGoodNote(this.formulationId, payload)
        await this.$emit('refreshGeneral', '')
        this.showSuccessMessage('DGN Updated successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    }
  },
  async mounted() {
    this.formulationId = this.$route.params.id
    if (this.formulation.is_dgn_required) {
      this.form = this.formulation.dangerous_goods_note
      this.is_dgn_required = true
    } else {
      this.form = {}
      this.is_dgn_required = false
    }

  },
  computed: {
    formulation: function () {
      return this.formulation_data
    },
    formulationDgnPermissions: function () {
      return this.formulationPermissions.concat(['ops-elements-edit', 'qc-elements-edit'])
    },
  },
  mixins: [SuccessMessage, ErrorMessages]
}
</script>

<style scoped>

.__table-heading-small {
  /*font-size: x-small;*/
  /*font-weight: normal;*/
}

</style>
